import styles from './FAQSection.module.css'

type FAQ = { q: string; a: string }

const FAQS: FAQ[] = [
  {
    q: 'Tem versão grátis mesmo? Onde tá a pegadinha?',
    a:
      'Sim — versão grátis pra valer. Você cria ligas privadas com amigos, joga nos 3 formatos com pontuação ao vivo e acompanha ranking global, sem cobrança e sem trial expirando. O Pro destrava ligas pagas com prize pool, mais competições simultâneas e regras 100% customizáveis. Se você só quer jogar com a galera, o Free resolve.',
  },
  {
    q: 'Como funciona uma liga privada com amigos?',
    a:
      'Você cria a liga em 30 segundos, escolhe o formato (pontos corridos, H2H semanal ou Sobrevivente) e manda o código de convite. Quem entra monta o próprio time e a competição começa. Cada liga é independente, com regras e configurações próprias — quem cria, manda.',
  },
  {
    q: 'O que tem de diferente das outras plataformas?',
    a:
      'Três coisas que ninguém mais tem: (1) você define as regras da sua liga — pontuação, formato, transferências, prize pool, tudo configurável; (2) três formatos de jogo (pontos corridos, H2H semanal e o Sobrevivente, o eliminatório que só existe aqui); (3) plataforma multi-esporte — futebol agora, CS2 em set/2026, basquete em out/2026.',
  },
  {
    q: 'Quando começa? Já tô atrasado?',
    a:
      'Lançamento na abertura da Copa de Seleções 2026 — 11 de junho. Beta fechado acontece antes, e quem entra na lista de espera ganha acesso antecipado. Tá no momento certo pra entrar.',
  },
  {
    q: 'Como vocês ganham dinheiro?',
    a:
      'Assinatura mensal opcional: Free pra sempre, Pro a R$ 19/mês destrava mais competições e ligas pagas, Elite a R$ 49/mês é pra quem joga sério em múltiplas ligas pagas. Em ligas pagas, retemos uma pequena taxa do prize pool. Sem anúncios, sem venda de dados — você é o cliente, não o produto.',
  },
]

export function FAQSection() {
  return (
    <section className={styles.section} id="faq">
      <div className={styles.head}>
        <div>
          <div className={styles.num}>05 / DÚVIDAS</div>
          <h2 className={styles.heading}>
            Perguntas que <span className={styles.glow}>todo mundo faz.</span>
          </h2>
        </div>
        <div className={styles.headRight}>
          Direto ao ponto, sem rodeio de marketing. Se sua dúvida não tá aqui,
          escreve pra <strong>contato@fantyx.pro</strong>.
        </div>
      </div>

      <div className={styles.list}>
        {FAQS.map((faq) => (
          <details key={faq.q} className={styles.item}>
            <summary className={styles.summary}>
              <span className={styles.q}>{faq.q}</span>
              <span className={styles.toggle} aria-hidden="true" />
            </summary>
            <div className={styles.a}>{faq.a}</div>
          </details>
        ))}
      </div>
    </section>
  )
}
